import React from "react";

export const IconLinkAvima = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="2" fill="#D8D8D8" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.0998 5.39413C13.0031 3.21011 15.4913 2.64417 18 2.5V5.32511C15.917 5.46468 14.4458 5.90792 13.3074 7.21465C12.7618 7.84041 12.3991 8.50145 12.1185 9.19315L12.1216 9.19622C12.1216 9.19622 12.1169 9.20082 12.1153 9.20235C11.9797 9.53517 11.863 9.87566 11.7542 10.2238C11.6959 10.4079 11.6328 10.618 11.5681 10.8342C11.4625 11.1885 11.3505 11.5612 11.2417 11.8787C11.0541 12.4324 10.816 13.0275 10.4549 13.5796L10.436 13.6087C10.0371 14.2207 9.28018 15.3756 7.6939 16.2636C6.35203 17.0136 4.53237 17.512 2.01735 17.4998V14.6854C4.13659 14.6977 5.43747 14.279 6.25111 13.8235C7.2177 13.2836 7.65921 12.6087 8.01242 12.0704C8.18587 11.8051 8.33567 11.4631 8.49335 10.9999C8.50123 10.9769 8.50912 10.9523 8.517 10.9293C7.52676 11.0689 6.67054 10.983 6.17227 10.9032C5.05746 10.7223 3.16212 10.1594 2 8.28672L4.47719 6.83276C5.00384 7.68244 5.89475 8.00299 6.64216 8.12415C7.34385 8.23765 8.62895 8.28979 9.71696 7.50453C10.0528 6.80975 10.4928 6.0935 11.0998 5.39566V5.39413Z"
        fill="#F55D27"
      />
    </svg>
  );
};
